<div class="flex flex-col flex-auto min-w-0">
  <div class="flex flex-auto flex-col overflow-hidden">
    <div class="flex flex-col border-b">
      <!-- <div class="flex items-start text-theme-gray">
        <a mat-button (click)="back()"> <mat-icon>keyboard_backspace</mat-icon> Back </a>
      </div> -->
      <div class="flex flex-row justify-between items-center px-6 py-4">
        <div class="text-h5 text-bold overflow-hidden whitespace-pre text-ellipsis w-[200px] md:w-[500px] lg:w-[800px]" [matTooltip]="item.name">{{ item.name }}</div>
        <div class="flex flex-row gap-4">
          <red-table-action-group [item]="item" [actions]="buttons" (actionClick)="actionClick($event, item)"> </red-table-action-group>

          <mat-divider vertical class="h-6"></mat-divider>

          <button type="button" mat-icon-button [autofocus]="false" [matTooltip]="'Close'" queryParamsHandling="merge" (click)="back()">
            <mat-icon class="text-theme-gray">clear</mat-icon>
          </button>
        </div>
      </div>
      <div class="flex flex-row items-center px-6 pb-2">
        <red-last-updated-information [updatedBy]="item.updatedBy" [updatedAt]="item.updatedAt"></red-last-updated-information>
      </div>
    </div>
    <div class="relative flex flex-col flex-auto overflow-hidden scroll-smooth">
      <red-dynamic-report-general-form
        #dynamicReportGeneralFormComponent
        [item]="item"
        [reportTypes]="reportTypes"
        [isDetail]="true"
      ></red-dynamic-report-general-form>
    </div>
  </div>
</div>
